module.exports = __webpack_public_path__ + "static/media/caption-this-logo.d659daba.png";